import { render } from "./EvangelioComponent.vue?vue&type=template&id=25251646"
import script from "./EvangelioComponent.vue?vue&type=script&lang=js"
export * from "./EvangelioComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue\\evangelio-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__